/**
 * Application configuration. Mirrors BigxBookApp/src/config.ts but reads
 * values from Vite's import.meta.env so a single binary can be re-pointed
 * by an installer-time env file later.
 */
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL?.replace(/\/+$/, '') ?? 'http://localhost:6001';

export const API_URL = `${API_BASE_URL}/api`;

export const APP_ENV = import.meta.env.VITE_APP_ENV ?? 'development';
export const IS_DEV = APP_ENV === 'development';

export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN ?? '';

if (!IS_DEV && !API_BASE_URL.startsWith('https://')) {
  // SECURITY: production builds must use HTTPS. Mirror BigxBook guarantee.
  throw new Error(`SECURITY: Production API_BASE_URL must use HTTPS. Got: ${API_BASE_URL}`);
}
